"use strict";

var _slicedToArray = require("/home/runner/work/typedraft-playground/typedraft-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/home/runner/work/typedraft-playground/typedraft-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/typedraft-playground/typedraft-playground/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var InlineContext =
/*#__PURE__*/
function () {
  function InlineContext(path) {
    _classCallCheck(this, InlineContext);

    this.m_Path = path;
  }

  _createClass(InlineContext, [{
    key: "ToStatements",
    value: function ToStatements() {
      return this.m_Code.body;
    }
  }, {
    key: "Resolve",
    value: function Resolve(dsl) {
      if (dsl.m_Merge) {
        this.m_Path.replaceWithMultiple(dsl.Transcribe(this.ToStatements(), this.m_Path));
      } else {
        this.m_Code.body = dsl.Transcribe(this.ToStatements(), this.m_Path);
      }
    }
  }, {
    key: "GetDSLName",
    value: function GetDSLName() {
      var statement = this.m_Path.node.body[0];

      if (!statement || !types_1.isStringLiteral(statement.expression)) {
        return "";
      }

      var _statement$expression = statement.expression.value.trim().split(" "),
          _statement$expression2 = _slicedToArray(_statement$expression, 2),
          dsl_name = _statement$expression2[1];

      return dsl_name;
    }
  }, {
    key: "m_ID",
    get: function get() {
      return Symbol();
    }
  }, {
    key: "m_Code",
    get: function get() {
      return this.m_Path.node;
    }
  }]);

  return InlineContext;
}();

exports.InlineContext = InlineContext;

var types_1 = require("@babel/types");